import { ColorPaletteType, ThemeTokensType } from 'src/domains/common/themesStar';

export const themeTokens: ThemeTokensType = {
    /* -> To do - please add this to proper component <- */
    accordion: {
        bgSection: '#34536f',
        bgSports: '#61798f',
        bgCompetition: '#a4b2bf',
        bgOutright: '#c1ccd7',
        bgMarket: '#e8ebef',
        fgSection: '#ffffff',
        fgSports: '#ffffff',
        fgCompetition: '#020d16',
        fgOutright: '#020d16',
        fgMarket: '#020d16',
        brSection: '#61798f',
        brSports: '#a4b2bf',
        brCompetition: '#c1ccd7',
        brOutright: '#e8ebef',
        brMarket: '#f2f2f2',
    },
    /* -> To do - please add this to proper component <- */
    badge: {
        bgPrimary: '#fdc500',
        fgPrimary: '#020d16',
        bgSecondary: '#055ca9',
        fgSecondary: '#ffffff',
        bgTertiary: '#ffffff',
        fgTertiary: '#020d16',
    },
    /* -> Done <- */
    brand: {
        primary: '#072d4f',
        secondary: '#fdc500',
        tertiary: '#055ca9',
    },
    /* -> To do - please add this to proper component <- */
    button: {
        primary: {
            bgDefault: '#fdc500',
            bgHover: '#ffce22',
            fgDefault: '#0c0c0c',
            fgDisabled: 'rgba(12 12 12 / 0.24)',
        },
        secondary: {
            bgDefault: '#e8ebef',
            bgHover: '#d5d8dc',
            fgDefault: '#0c0c0c',
            fgDisabled: 'rgba(12 12 12 / 0.32)',
        },
        tertiary: {
            bgDefault: '#ffffff',
            bgHover: '#ebebeb',
            fgDefault: '#0c0c0c',
            fgDisabled: 'rgba(12 12 12 / 0.16)',
        },
    },
    chip: {
        primary: {
            bgActive: '#ffffff',
            fgActive: '#020d16',
            brDefault: '#ffffff',
            fgDefault: '#ffffff',
        },
        secondary: {
            bgActive: '#055ca9',
            fgActive: '#ffffff',
            brDefault: '#055ca9',
            fgDefault: '#055ca9',
        },
    },
    control: {
        bgSelected: '#39b54a',
        pagination: {
            fgLightSelected: '#055ca9',
            fgDarkSelected: '#fdc500',
        },
        scrollbar: {
            bgLight: 'rgba(155 155 155 / 0.35)',
            bgDark: 'rgba(155 155 155 / 0.35)',
        },
    },
    elevation: {
        down: {
            sm: '0 2px 8px 0 rgba(0 0 0 / 0.12)',
            md: '0 4px 8px 0 rgba(0 0 0 / 0.16)',
            lg: '0 12px 40px 0 rgba(0 0 0 / 0.24)',
        },
        right: {
            md: '4px 0 8px 0 rgba(0 0 0 / 0.16)',
        },
        bet: {
            header: '0 4px 4px 0 rgba(0 0 0 / 0.25)',
            footer: '0 -2px 8px 0 rgba(0 0 0 / 0.32)',
        },
        rhs: '-4px 4px 16px 0 rgba(0 0 0 / 0.16)',
        modal: '0 0 16px 0 rgba(0 0 0 / 0.16)',
        toggle: '0 0 4px 0 rgba(0 0 0 / 0.16)',
        focus: {
            primary2px: '0 0 0 2px rgba(253 197 0 / 0.2), 0 1px 2px 0 rgba(0 0 0 / 0.05)',
            error2px: '0 0 0 2px rgba(232 55 55 / 0.2), 0 1px 2px 0 rgba(0 0 0 / 0.05)',
        },
    },
    gradient: {
        scoreboardOverlay: 'linear-gradient(90deg, #072d4f00 0.1%, #072d4fcc 54.32%, #072d4f8f 100%)',
    },
    /* -> To do - please add this to proper component <- */
    link: {
        primaryDefault: '#fdc500',
        secondaryDefault: '#055ca9',
        tertiaryDefault: '#ffffff',
    },
    /* -> To do - please add this to proper component <- */
    navbar: {
        bg: '#072d4f',
        fgDefault: '#ffffff',
        fgSelected: '#fdc500',
    },
    oddsKey: {
        price: {
            default: '#055ca9',
        },
        odds: {
            shortening: '#bbd8f3',
            drifting: '#f7b1b1',
            suspended: '#f2f2f2',
        },
    },
    opacity: {
        dark8: 'rgba(0 0 0 / 0.08)',
        dark16: 'rgba(0 0 0 / 0.16)',
        dark32: 'rgba(0 0 0 / 0.32)',
        dark64: 'rgba(0 0 0 / 0.64)',
        dark80: 'rgba(0 0 0 / 0.8)',
        light8: 'rgba(255 255 255 / 0.08)',
        light16: 'rgba(255 255 255 / 0.16)',
        light32: 'rgba(255 255 255 / 0.32)',
        light64: 'rgba(255 255 255 / 0.64)',
        light80: 'rgba(255 255 255 / 0.8)',
    },
    override: {
        style1: '#d9d9d9',
        style2: '#d9d9d9',
        style3: '#d9d9d9',
        style4: '#d9d9d9',
    },
    /* -> To do - please add this to proper component <- */
    score: {
        bgDefault: '#055ca9',
        fgDefault: '#ffffff',
        scoreboard: {
            bgDefault: '#055ca9',
            fgDefault: '#ffffff',
        },
    },
    /* -> To do - please add this to proper component <- */
    selection: {
        bgDefault: '#ffffff',
        br: '#c1ccd7',
        fgPrimary: '#020d16',
        fgSecondary: 'rgba(2 13 22 / 0.4)',
    },
    shade: {
        dark: '#020d16',
        shade1: '#34536f',
        shade2: '#61798f',
        shade3: '#a4b2bf',
        shade4: '#c1ccd7',
        shade5: '#e8ebef',
        shade6: '#f2f2f2',
        white: '#ffffff',
    },
    /* -> To do - please add this to proper component <- */
    status: {
        /* -> Done <- */
        error: '#e83737',
        warning: '#f59e0b',
        /* -> Done <- */
        success: '#39b54a',
        bgInfo: '#055ca9',
    },
    text: {
        secondary: '#fdc500',
        tertiary: '#055ca9',
        dark: '#020d16',
        dark16: 'rgba(0 0 0 / 0.16)',
        dark32: 'rgba(0 0 0 / 0.4)',
        dark64: 'rgba(0 0 0 / 0.64)',
        dark80: 'rgba(0 0 0 / 0.8)',
        light: '#ffffff',
        light16: 'rgba(255 255 255 / 0.16)',
        light32: 'rgba(255 255 255 / 0.32)',
        light64: 'rgba(255 255 255 / 0.64)',
        light80: 'rgba(255 255 255 / 0.8)',
    },
    textLink: {
        primaryDefault: '#fdc500',
        secondaryDefault: '#055ca9',
        tertiaryDefault: '#ffffff',
    },
};

const colorPalette: ColorPaletteType = {
    main: {
        primary: '#13294B',
        secondary: '#FEBE10',
        tertiary: '#1B57B2',
        quaternary: '#8D0F16',
    },
    shade: {
        dark: '#0A1C30',
        shade1: '#18365D',
        shade2: '#20416D',
        shade3: '#264D7B',
        shade4: '#2D5589',
        shade5: '#305A91',
        shade6: '#F8FAFC',
        white: '#ffffff',
    },
    odds: {
        oddsDrifting: '#f7b1b1',
        oddsShortening: '#bbd8f3',
        oddsSuspended: '#bebebe',
    },
    text: {
        textDark: '#0A1C30',
        textDark40: 'rgba(3, 16, 29, 0.40)',
        textDark48: 'rgba(3, 16, 29, 0.48)',
        textDark64: 'rgba(3, 16, 29, 0.64)',
        textDark80: 'rgba(3, 16, 29, 0.8)',
        textLight: '#ffffff',
        textLight40: 'rgba(255, 255, 255, 0.4)',
        textLight64: 'rgba(255, 255, 255, 0.64)',
        textLight80: 'rgba(255, 255, 255, 0.8)',
        textSecondary: '#fdc500',
        textSecondary80: 'rgba(253, 197, 0, 0.8)',
        textTertiary: '#055ca9',
        textTertiary80: '',
        textQuaternary: '',
    },
    status: {
        statusError: '#EF4444',
        statusWarning: '#F97316',
        statusSuccess: '#22C55E',
    },
    opacity: {
        opacityDark10: 'rgba(3, 16, 29, 0.1)',
        opacityDark20: 'rgba(3, 16, 29, 0.2)',
        opacityDark40: 'rgba(3, 16, 29, 0.4)',
        opacityDark8: 'rgba(3, 16, 29, 0.08)',
        opacityDark80: 'rgba(3, 16, 29, 0.8)',
        opacityPrimary80: 'rgba(7, 30, 59, 0.8)',
        opacityWhite10: 'rgba(255, 255, 255, 0.10)',
        opacityWhite12: 'rgba(255, 255, 255, 0.12)',
        opacityWhite20: 'rgba(255, 255, 255, 0.2)',
        opacityWhite40: 'rgba(255, 255, 255, 0.4)',
        opacityWhite8: 'rgba(255, 255, 255, 0.08)',
        opacityWhite80: 'rgba(255, 255, 255, 0.8)',
    },
};

export const layoutGlobal = {
    bgColor: colorPalette.shade.dark,
    txtColor: colorPalette.text.textLight,
    linkColor: colorPalette.main.secondary,
};

export const fontFamily = {
    fontFamily: "'Satoshi', Arial, sans-serif",
};

export const fontSize = {
    /** font-size: 8px */
    xxSmall: '0.8rem',
    /** font-size: 10px */
    xSmall: '1rem',
    /** font-size: 12px */
    small: '1.2rem',
    /** font-size: 14px */
    xRegular: '1.4rem',
    /** font-size: 16px */
    regular: '1.6rem',
    /** font-size: 18px */
    xxMedium: '1.8rem',
    /** font-size: 20px */
    xMedium: '2rem',
    /** font-size: 24px */
    medium: '2.4rem',
    /** font-size: 32px */
    big: '3.2rem',
    /** font-size: 48px */
    xxxBig: '4.8rem',
};

export const lineHeight = {
    /** line-height: 1.2 */
    150: '1.2',
    /** line-height: 1.3334 */
    200: '1.3334',
    /** line-height: 1.4286 */
    250: '1.4286',
    /** line-height: 1.5 */
    300: '1.5',
    350: '',
    400: '1.6',
    500: '',
};

export const fontWeight = {
    /** font-weight: 400 */
    regular: '400',
    /** font-weight: 500 */
    medium: '500',
    /** font-weight: 600 */
    xMedium: '600',
    /** font-weight: 700 */
    bold: '700',
};

export const mediaQuery = {
    /** mobile: 375px */
    mobile: 'screen and (min-width: 375px)',
    /** mobile: 415px */
    xMobile: 'screen and (min-width: 415px)',
    /** largeMobile: 480px */
    xxMobile: 'screen and (min-width: 480px)',
    /** tablet: 768px */
    tablet: 'screen and (min-width: 768px)',
    /** desktop: 1024px */
    desktop: 'screen and (min-width: 1024px)',
    /** large desktop: 1200px */
    largeDesktop: 'screen and (min-width: 1200px)',
    /** x large desktop: 1366px */
    xLargeDesktop: 'screen and (min-width: 1366px)',
    /** xx large desktop: 1440px */
    xxLargeDesktop: 'screen and (min-width: 1440px)',
};

export const padding = {
    /** padding: 0px */
    none: '0',
    /** padding: 2px */
    xSmall: '2px',
    /** padding: 4px */
    small: '4px',
    /** padding: 8px */
    medium: '8px',
    /** padding: 12px */
    xMedium: '12px',
    /** padding: 16px */
    large: '16px',
    /** padding: 24px */
    xLarge: '24px',
    /** padding: 32px */
    xxLarge: '32px',
    /** padding: 48px */
    xxxLarge: '48px',
};

export const radius = {
    /** radius: 0px */
    none: '0',
    /** radius: 2px */
    xSmall: '2px',
    /** radius: 4px */
    small: '4px',
    /** radius: 8px */
    medium: '8px',
    /** radius: 16px */
    large: '16px',
    /** radius: 24px */
    xLarge: '24px',
    /** radius: 9999px (circular) */
    circular: '9999px',
};

export const gap = {
    /** gap: 0px */
    none: '0',
    /** gap: 2px */
    xSmall: '2px',
    /** gap: 4px */
    small: '4px',
    /** gap: 8px */
    medium: '8px',
    /** gap: 16px */
    large: '16px',
    /** gap: 24px */
    xLarge: '24px',
    /** gap: 32px */
    xxLarge: '32px',
};

export const form = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.shade.shade6,
    bgColorTertiary: colorPalette.shade.dark,
    bgColorQuaternary: colorPalette.main.tertiary,

    borderColor: colorPalette.main.secondary,
    borderColorSecondary: colorPalette.shade.shade4,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textDark48,
    txtColorTertiary: colorPalette.shade.dark,
    txtColorQuaternary: colorPalette.text.textLight,

    dark: {
        bgColor: colorPalette.shade.white,
        borderColor: colorPalette.shade.white,
        txtColor: colorPalette.text.textLight,
    },
    light: {
        bgColor: colorPalette.shade.shade6,
        borderColor: colorPalette.shade.shade6,
        txtColor: colorPalette.text.textDark,
    },
};

export const radioButton = {
    dark: {
        bgColor: colorPalette.shade.white,
        borderColor: colorPalette.shade.white,
        borderColorSecondary: colorPalette.shade.white,
    },
    light: {
        bgColor: colorPalette.main.tertiary,
        borderColor: colorPalette.shade.shade3,
        borderColorSecondary: colorPalette.shade.shade3,
    },
};

export const loader = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.shade.white,
    bgColorTertiary: colorPalette.main.tertiary,
};

export const headerMain = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.opacity.opacityWhite8,
    bgColorTertiary: colorPalette.shade.white,
    bgColorQuaternary: colorPalette.main.primary,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.main.secondary,
    txtColorTertiary: colorPalette.text.textLight,
};

export const statuses = {
    error: {
        bgColor: colorPalette.status.statusError,
        bgColorSecondary: 'transparent',
        txtColor: colorPalette.text.textLight,
        txtColorSecondary: colorPalette.status.statusError,
    },
    info: {
        bgColor: colorPalette.main.tertiary,
        txtColor: colorPalette.text.textLight,
    },
    warning: {
        bgColor: colorPalette.status.statusWarning,
        txtColor: colorPalette.text.textLight,
    },
    success: {
        bgColor: colorPalette.status.statusSuccess,
        txtColor: colorPalette.text.textLight,
    },
    text: {
        error: {
            txtColor: colorPalette.text.textLight,
        },
        info: {
            txtColor: colorPalette.text.textLight,
        },
    },
};

export const filtersColors = {
    primary: {
        bgColor: colorPalette.shade.white,
        txtColor: colorPalette.text.textLight,
        bgColorSecondary: 'transparent',
        txtColorSecondary: colorPalette.text.textDark,
        borderColor: colorPalette.shade.white,
        borderColorSecondary: colorPalette.shade.white,
    },
    secondary: {
        bgColor: colorPalette.main.secondary,
        bgColorSecondary: 'transparent',
        txtColor: colorPalette.main.secondary,
        txtColorSecondary: colorPalette.text.textDark,
        borderColor: colorPalette.main.secondary,
        borderColorSecondary: colorPalette.main.secondary,
    },
    tertiary: {
        bgColor: colorPalette.main.tertiary,
        bgColorSecondary: 'transparent',
        txtColor: colorPalette.main.tertiary,
        txtColorSecondary: colorPalette.text.textLight,
        borderColor: colorPalette.main.tertiary,
        borderColorSecondary: colorPalette.main.tertiary,
    },
    wrapper: {
        bgColor: colorPalette.main.primary,
        bgColorSecondary: colorPalette.shade.dark,
        bgColorTertiary: colorPalette.shade.shade1,
        bgColorQuaternary: colorPalette.shade.shade1,
        borderColor: colorPalette.shade.shade2,
    },
    dropdown: {
        bgColor: colorPalette.shade.dark,
        bgColorSecondary: colorPalette.main.tertiary,
        txtColor: colorPalette.text.textLight,
    },
    radius: radius.small,
};

export const cookieMessage = {
    bgColor: colorPalette.shade.white,
    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textTertiary,
};

export const bannerBox = {
    bgColor: colorPalette.shade.white,
    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textDark80,
};

export const eventsGroupedFiltersColors = {
    bgColor: colorPalette.shade.shade2,
    bgColorSecondary: 'transparent',
    txtColor: colorPalette.shade.white,
};

export const eventsTableColors = {
    bgColor: colorPalette.shade.shade1,
    bgColorSecondary: colorPalette.shade.white,
    borderColor: 'rgba(0,0,0,0.05)',
    txtColor: colorPalette.shade.white,
};

export const rhsMainNavigation = {
    bgColor: colorPalette.main.secondary,
    bgColorSecondary: colorPalette.opacity.opacityWhite20,
    borderColor: colorPalette.opacity.opacityDark20,
    txtColor: colorPalette.text.textDark,
};

export const counter = {
    bets: {
        bgColor: colorPalette.main.secondary,
        txtColor: colorPalette.text.textDark,
    },
    chat: {
        bgColor: colorPalette.main.tertiary,
        txtColor: colorPalette.text.textLight,
    },
    rewards: {
        bgColor: colorPalette.shade.white,
        bgColorSecondary: colorPalette.shade.white,

        txtColor: colorPalette.text.textDark,
        txtColorSecondary: colorPalette.text.textDark,
    },
};

export const heroWidget = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.shade.shade1,
    bgColorTertiary: colorPalette.shade.dark,
    bgColorQuaternary: '',
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.main.secondary,
    borderColor: colorPalette.shade.shade2,
};

export const heroSingleMarket = {
    bgColor: colorPalette.shade.shade2,
    bgColorSecondary: colorPalette.shade.shade3,
    bgColorTertiary: colorPalette.opacity.opacityWhite20,
    bgColorQuaternary: colorPalette.shade.shade3,
    borderColor: colorPalette.shade.shade2,
    txtColor: colorPalette.shade.white,
    txtColorSecondary: colorPalette.main.tertiary,
};

export const heroSelection = {
    bgColor: colorPalette.shade.shade3,
    txtColor: colorPalette.text.textSecondary,
    txtColorSecondary: colorPalette.shade.white,
};

export const accountPanel = {
    bgColor: colorPalette.main.primary,
    txtColor: colorPalette.text.textLight,
    shadowColor: colorPalette.opacity.opacityDark20,
};

export const accountDrawer = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.shade.shade6,
    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textTertiary,
};

export const accountSummary = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.shade.shade6,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textDark,
    txtColorTertiary: colorPalette.main.secondary,
    txtColorQuaternary: colorPalette.status.statusError,
    txtColorQuinary: colorPalette.main.tertiary,
};

export const card = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.main.tertiary,
    bgColorTertiary: colorPalette.shade.shade6,

    borderColor: colorPalette.opacity.opacityDark8,
    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textDark48,
};

export const badge = {
    bgColor: colorPalette.shade.shade6,
    bgColorSecondary: colorPalette.main.primary,

    borderColor: colorPalette.shade.shade6,
    borderColorSecondary: colorPalette.main.secondary,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textLight,
};

export const topUp = {
    bgColor: colorPalette.shade.shade6,
    bgColorSecondary: colorPalette.main.primary,
    bgColorTertiary: colorPalette.opacity.opacityDark8,

    borderColor: colorPalette.shade.shade4,

    txtColor: colorPalette.text.textDark80,
    txtColorSecondary: colorPalette.text.textTertiary,
    txtColorTertiary: colorPalette.text.textDark,
    txtColorQuaternary: colorPalette.text.textLight40,
    txtColorQuinary: colorPalette.text.textTertiary,

    iconColor: colorPalette.shade.dark,
};

export const pendingTransactions = {
    bgColor: colorPalette.shade.shade6,
    bgColorSecondary: colorPalette.shade.white,
    bgColorTertiary: colorPalette.odds.oddsShortening,
    borderColor: colorPalette.opacity.opacityDark8,

    txtColor: colorPalette.opacity.opacityDark80,
    txtColorSecondary: colorPalette.text.textDark,
    txtColorTertiary: colorPalette.text.textDark48,
    txtColorQuaternary: '',
};

export const accountLinks = {
    borderColor: colorPalette.opacity.opacityDark8,
    txtColor: colorPalette.text.textDark,
};

export const accountHelperInfo = {
    txtColor: colorPalette.text.textDark48,
};

export const utilityPage = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.opacity.opacityWhite10,
    bgColorTertiary: colorPalette.opacity.opacityDark10,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.main.secondary,
    txtColorTertiary: colorPalette.text.textLight80,
    txtColorQuaternary: colorPalette.text.textDark,
    txtColorQuinary: colorPalette.text.textDark,
};

export const accountHistoryHeader = {
    bgColor: colorPalette.shade.shade6,
    txtColor: colorPalette.text.textDark80,
};

export const betHistory = {
    bgColor: colorPalette.main.tertiary,
    bgColorSecondary: colorPalette.main.primary,
    borderColor: colorPalette.opacity.opacityDark8,

    txtColor: colorPalette.text.textDark48,
    txtColorSecondary: colorPalette.text.textDark,
    txtColorTertiary: colorPalette.text.textDark80,
    txtColorQuaternary: colorPalette.text.textTertiary,
    txtColorQuinary: colorPalette.text.textDark,
};

export const traderChat = {
    messages: {
        bgColor: colorPalette.shade.white,
        bgColorSecondary: colorPalette.shade.shade5,
        bgColorTertiary: colorPalette.shade.shade1,
        bgColorQuaternary: colorPalette.status.statusSuccess,
        bgColorQuinary: colorPalette.shade.white,

        borderColor: colorPalette.opacity.opacityDark20,
        borderColorSecondary: colorPalette.opacity.opacityDark10,

        txtColor: colorPalette.text.textDark,
        txtColorSecondary: colorPalette.text.textLight,
        txtColorTertiary: colorPalette.text.textDark48,
        txtColorQuaternary: colorPalette.text.textLight,
    },
    notification: {
        bgColor: colorPalette.shade.shade1,
        bgColorSecondary: colorPalette.main.secondary,
        bgColorTertiary: colorPalette.shade.dark,
        txtColor: colorPalette.text.textLight,
    },
};

export const tooltip = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.main.tertiary,
    bgColorTertiary: colorPalette.status.statusError,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight,
    txtColorTertiary: colorPalette.text.textLight,
};

export const casino = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.shade.white,
    bgColorTertiary: colorPalette.main.primary,
    bgColorQuaternary: colorPalette.main.primary,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight64,
    txtColorTertiary: colorPalette.text.textLight,
    txtColorQuaternary: colorPalette.text.textDark,

    banners: {
        txtColor: colorPalette.text.textLight,
    },

    game: {
        bgColor: colorPalette.opacity.opacityDark80,
        bgColorSecondary: colorPalette.main.secondary,

        radius: radius.medium,
    },

    gameInfo: {
        bgColor: colorPalette.shade.shade6,
        bgColorSecondary: 'linear-gradient(35deg, rgba(115, 115, 115, 0.2) 0%, rgba(230, 230, 230, 0.6) 100%)',
        bgColorTertiary: colorPalette.shade.shade1,
        bgColorQuaternary: colorPalette.shade.white,
        txtColor: colorPalette.text.textDark,
        txtColorSecondary: colorPalette.text.textTertiary,
        txtColorTertiary: colorPalette.main.secondary,
        txtColorQuaternary: colorPalette.text.textDark,
        txtColorQuinary: colorPalette.text.textDark48,
        borderColor: colorPalette.opacity.opacityDark10,
    },

    liveCasino: {
        bgColor: colorPalette.opacity.opacityPrimary80,
        bgColorSecondary: colorPalette.opacity.opacityDark40,
        bgColorTertiary: colorPalette.opacity.opacityDark80,

        borderColor: colorPalette.opacity.opacityWhite20,

        number: {
            hot: {
                bgColor: colorPalette.status.statusError,
                txtColor: colorPalette.shade.white,
            },
            cold: {
                bgColor: colorPalette.shade.white,
                txtColor: colorPalette.shade.dark,
            },
            red: {
                borderColor: colorPalette.status.statusError,
                txtColor: colorPalette.status.statusError,
            },
            black: {
                borderColor: colorPalette.opacity.opacityWhite20,
                txtColor: colorPalette.shade.white,
            },
            green: {
                borderColor: colorPalette.status.statusSuccess,
                txtColor: colorPalette.status.statusSuccess,
            },
        },
    },

    casinoMini: {
        colors: {
            bgPrimary: colorPalette.shade.shade1,
            bgSecondary: colorPalette.main.secondary,
            bgTertiary: colorPalette.shade.shade1,
            bgQuaternary: colorPalette.main.secondary,

            txtPrimary: colorPalette.text.textLight,
            txtSecondary: colorPalette.text.textLight,
        },
        radius: radius.medium,
    },

    casinoSlider: {
        bgColor: colorPalette.main.secondary,
        txtColor: colorPalette.main.secondary,
    },

    virtualsGamesBar: {
        txtColor: colorPalette.main.primary,
        txtColorSecondary: colorPalette.shade.white,
        bgColor: colorPalette.shade.white,
        bgColorSecondary: colorPalette.shade.dark,
    },
};

export const verifyAccountTab = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: '#f8f9fb',
    bgColorTertiary: colorPalette.shade.shade6,
    txtColor: colorPalette.shade.dark,
    txtColorSecondary: colorPalette.main.tertiary,
};

export const odds = {
    bgColor: colorPalette.odds.oddsDrifting,
    bgColorSecondary: colorPalette.odds.oddsShortening,
    bgColorTertiary: colorPalette.odds.oddsSuspended,
    bgColorQuaternary: colorPalette.shade.shade6,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.opacity.opacityDark40,
    txtColorTertiary: colorPalette.opacity.opacityWhite40,
};

export const eachWayBox = {
    bgColor: colorPalette.shade.white,
    txtColor: colorPalette.text.textDark,
};

export const specialEventsColors = {
    bgColor: colorPalette.shade.shade3,
    borderColor: colorPalette.shade.shade2,
    txtColor: colorPalette.shade.white,
};

export const betslipSummary = {
    bgColor: colorPalette.opacity.opacityWhite12,
    borderColor: colorPalette.status.statusSuccess,
    borderColorSecondary: colorPalette.status.statusError,
    txtColor: colorPalette.shade.white,
};

export const betslipSelection = {
    bgColor: colorPalette.status.statusSuccess,
    bgColorSecondary: colorPalette.status.statusError,
    bgColorTertiary: `linear-gradient(90deg, ${colorPalette.status.statusSuccess} 50%, ${colorPalette.opacity.opacityWhite20} 50%)`,
    bgColorQuaternary: `linear-gradient(90deg, ${colorPalette.status.statusError} 50%, ${colorPalette.opacity.opacityWhite20} 50%)`,
    bgColorQuinary: colorPalette.shade.shade6,
};

export const betslipSelectionList = {
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight64,
    txtColorTertiary: colorPalette.text.textSecondary,
};

export const betSlipTooltip = {
    bgColor: colorPalette.main.tertiary,
    txtColor: colorPalette.text.textLight,
    borderColor: colorPalette.main.tertiary,
};

export const betslipGeneral = {
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textDark,
    txtColorTertiary: colorPalette.text.textSecondary,
    txtColorQuaternary: colorPalette.text.textLight80,
    txtColorSeptenary: colorPalette.text.textTertiary,

    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.shade.white,
    bgColorTertiary: colorPalette.shade.shade1,

    iconColorSwitch: colorPalette.shade.dark,
};

export const betSlipReceipt = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.opacity.opacityDark10,
    txtColor: colorPalette.main.primary,
    txtColorSecondary: colorPalette.shade.shade3,
    txtColorTertiary: colorPalette.text.textDark80,
    txtColorQuaternary: colorPalette.status.statusSuccess,
};

export const buttons = {
    primary: {
        bgColor: colorPalette.main.secondary,
        bgColorSecondary: colorPalette.opacity.opacityWhite20,
        txtColor: colorPalette.text.textDark,
    },
    secondary: {
        bgColor: '',
        bgColorSecondary: '',
        borderColor: '',
        txtColor: '',
        dark: {
            bgColor: colorPalette.opacity.opacityWhite12,
            bgColorSecondary: colorPalette.opacity.opacityWhite20,
            txtColor: colorPalette.text.textLight,
        },
        light: {
            bgColor: colorPalette.opacity.opacityDark8,
            bgColorSecondary: colorPalette.opacity.opacityDark20,
            txtColor: colorPalette.text.textDark,
        },
    },
    tertiary: {
        dark: {
            bgColor: '',
            bgColorSecondary: '',
            borderColor: '',
            txtColor: '',
            txtColorCarousel: '', // Temporary color for home page carousel -> will be moved to CMS.
        },
        light: {
            bgColor: '',
            bgColorSecondary: '',
            borderColor: '',
            txtColor: '',
        },
    },
};

export const bog = {
    bgColor: colorPalette.main.secondary,
    bgColorSecondary: colorPalette.shade.dark,
    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textSecondary,
};

export const bogBanner = {
    bgColor: colorPalette.main.secondary,
    txtColor: colorPalette.text.textDark,
};

export const footerMobile = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.shade.white,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textDark,
};

export const footerMain = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: '',
    bgColorTertiary: '',

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight80,
    txtColorTertiary: colorPalette.text.textLight40,
    txtColorQuinary: colorPalette.text.textLight,

    borderColor: '',
};

export const sidebar = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.opacity.opacityDark80,
    bgColorTertiary: colorPalette.shade.dark,
    txtColor: colorPalette.shade.white,
};

export const quickHeaderMain = {
    bgColor: colorPalette.shade.white,
    txtColor: colorPalette.shade.white,
    txtColorSecondary: colorPalette.main.primary,
};

export const lhsSidebar = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.main.primary,
    bgColorTertiary: '',
    bgColorQuaternary: colorPalette.shade.white,

    borderColor: `linear-gradient(270deg, ${colorPalette.main.secondary}, ${colorPalette.main.secondary} 100%)`,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight,
};

export const lhsNavigation = {
    bgColor: colorPalette.main.secondary,
    bgColorSecondary: colorPalette.opacity.opacityWhite20,
    bgColorTertiary: colorPalette.main.secondary,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight80,
    txtColorTertiary: colorPalette.text.textLight40,
};

export const moreLessButton = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: 'transparent',
    borderColor: colorPalette.shade.shade2,
    txtColor: colorPalette.main.secondary,
    txtColorSecondary: colorPalette.main.tertiary,
};

export const rabHeading = {
    bgColor: colorPalette.shade.shade1,
    bgColorSecondary: colorPalette.shade.shade1,
    bgColorTertiary: colorPalette.opacity.opacityWhite10,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: '',
    txtColorTertiary: colorPalette.text.textLight,
};

export const rabSelection = {
    bgColor: colorPalette.main.secondary,
    bgColorSecondary: colorPalette.shade.dark,
    bgColorTertiary: colorPalette.main.secondary,
    txtColor: colorPalette.text.textDark,
    borderColor: colorPalette.shade.shade2,
};

export const rabSelectionList = {
    bgColor: colorPalette.shade.shade1,
    bgColorSecondary: colorPalette.shade.shade3,
    bgColorTertiary: colorPalette.shade.shade1,
    bgColorQuaternary: colorPalette.main.secondary,
    bgColorQuinary: colorPalette.shade.shade1,

    borderColor: colorPalette.opacity.opacityWhite40,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textDark,
    txtColorTertiary: colorPalette.text.textSecondary,
};

export const browserUnsupported = {
    bgColor: colorPalette.main.primary,
    txtColor: colorPalette.text.textLight,
};

const gradients = {
    gradientScoreboardLinear:
        'linear-gradient(90.0deg, rgba(2, 13, 22, 0) 0%, rgba(7, 45, 79, 0.8) 54%, rgba(7, 45, 79, 0.32) 100%)',
};

export const collapse = {
    section: {
        bgColor: colorPalette.shade.shade1,
        bgColorSecondary: colorPalette.shade.white,
        borderColor: colorPalette.opacity.opacityWhite10,
        txtColor: colorPalette.text.textLight,
    },
    sport: {
        bgColor: colorPalette.shade.shade2,
        bgColorSecondary: colorPalette.shade.white,
        borderColor: colorPalette.opacity.opacityWhite10,
        txtColor: colorPalette.text.textLight,
    },
    racingAnd6Pack: {
        bgColor: colorPalette.shade.shade4,
        bgColorSecondary: colorPalette.shade.white,
        borderColor: colorPalette.opacity.opacityWhite10,
        txtColor: colorPalette.text.textLight,
    },
    competitionAndMarket: {
        bgColor: colorPalette.shade.shade4,
        bgColorSecondary: colorPalette.shade.white,
        borderColor: colorPalette.opacity.opacityWhite10,
        txtColor: colorPalette.text.textLight,
    },
    radius: radius.small,
};

export const headings = {
    sportBanner: {
        bgColor: colorPalette.shade.shade1,
        bgColorSecondary: colorPalette.shade.dark,
        bgColorTertiary: gradients.gradientScoreboardLinear,
        borderColor: colorPalette.shade.shade2,
        txtColor: colorPalette.shade.white,
        txtColorSecondary: colorPalette.shade.white,
    },
};

export const marketHeader = {
    bgColor: 'transparent',
    bgColorSecondary: colorPalette.shade.shade1,
    txtColor: colorPalette.main.secondary,
};

export const priceLegendList = {
    bgColor: colorPalette.shade.dark,
    txtColor: colorPalette.text.textLight,
    borderColor: colorPalette.shade.shade2,
    statusFirst: colorPalette.main.secondary,
    statusSecond: odds.bgColor,
    statusThird: odds.bgColorSecondary,
    statusFourth: odds.bgColorTertiary,
};

export const gamesOnHomepage = {
    bgColor: colorPalette.shade.shade1,
    txtColor: colorPalette.main.secondary,
};

export const signUp = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.opacity.opacityWhite12,
    bgColorTertiary: colorPalette.shade.white,
    bgColorQuaternary: colorPalette.main.secondary,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textSecondary,
    txtColorTertiary: colorPalette.text.textSecondary,
    txtColorQuaternary: '',
    borderColor: colorPalette.opacity.opacityWhite12,

    yourDetails: {
        bgColor: colorPalette.shade.shade6,
        txtColor: colorPalette.text.textTertiary,
    },
    breadcrumbs: {
        bgColor: statuses.success.bgColor,
        borderColor: colorPalette.shade.white,
    },
    termsAndConditions: {
        bgColor: colorPalette.shade.white,
        txtColor: colorPalette.text.textSecondary,
    },
    footer: {
        txtColor: colorPalette.text.textLight80,
        txtColorSecondary: colorPalette.shade.white,
        txtColorTertiary: colorPalette.opacity.opacityWhite20,
    },
};

export const overlay = {
    bgColor: colorPalette.opacity.opacityDark40,
    bgColorSecondary: colorPalette.opacity.opacityDark80,
};

export const watchLiveButton = {
    bgColor: colorPalette.status.statusSuccess,
    bgColorSecondary: colorPalette.shade.shade6,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.shade.shade2,
};

export const promoSidebarSection = {
    bgColor: colorPalette.main.primary,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight80,
    txtColorTertiary: colorPalette.text.textLight40,
    txtColorQuaternary: colorPalette.main.secondary,
};

export const selectionsGroup = {
    bgColor: colorPalette.shade.dark,
    borderColor: colorPalette.shade.shade2,
    txtColor: colorPalette.text.textLight,
    typography: {
        fontSizePrimary: fontSize.small,
        fontWeightPrimary: fontWeight.regular,
        lineHeightPrimary: lineHeight[200],
    },
};

export const marketGroupGoalscorer = {
    bgColor: colorPalette.main.secondary,
    bgColorSecondary: colorPalette.shade.shade1,
    bgColorTertiary: colorPalette.shade.white,
    bgColorQuaternary: colorPalette.shade.dark,

    borderColor: colorPalette.shade.shade2,

    txtColor: colorPalette.text.textLight64,

    filters: {
        bgColor: colorPalette.shade.shade1,
        bgColorSecondary: colorPalette.main.secondary,
        borderColor: colorPalette.main.secondary,
        txtColor: colorPalette.main.secondary,
        txtColorSecondary: colorPalette.text.textDark,
    },
};

export const searchBar = {
    bgColor: colorPalette.shade.shade2,
    bgColorSecondary: colorPalette.shade.shade6,
    bgColorTertiary: colorPalette.shade.white,
    bgColorQuaternary: colorPalette.main.primary,
    bgColorQuinary: colorPalette.shade.white,
    bgColorSenary: colorPalette.shade.dark,
    bgColorSeptenary: colorPalette.shade.white,

    borderColor: colorPalette.main.secondary,

    txtColor: colorPalette.text.textTertiary,
    txtColorSecondary: colorPalette.text.textDark,
    txtColorTertiary: colorPalette.text.textDark48,
    txtColorQuaternary: colorPalette.text.textLight40,
    txtColorQuinary: colorPalette.text.textDark,
    txtColorSenary: colorPalette.text.textDark48,
    txtColorSeptenary: colorPalette.text.textLight40,

    searchBarCasino: {
        bgColor: colorPalette.main.primary,
        borderColor: colorPalette.main.secondary,
        txtColor: colorPalette.shade.dark,
        radius: radius.small,
    },
};

export const raceCard = {
    filters: {
        time: {
            bgColor: colorPalette.shade.dark,
            bgColorSecondary: colorPalette.opacity.opacityDark8,

            borderColor: colorPalette.opacity.opacityWhite12,

            txtColor: colorPalette.main.secondary,
            txtColorSecondary: colorPalette.text.textLight,
        },
        type: {
            bgColor: colorPalette.shade.shade1,
            borderColor: colorPalette.shade.shade1,
        },
        name: {
            txtColor: colorPalette.shade.white,
        },
    },
    dropdown: {
        bgColor: colorPalette.shade.shade1,
        bgColorSecondary: colorPalette.main.tertiary,
        bgColorTertiary: colorPalette.shade.white,

        txtColor: colorPalette.shade.white,
    },
    details: {
        bgColor: colorPalette.shade.dark,

        txtColor: colorPalette.text.textLight,
    },
    stats: {
        bgColor: colorPalette.opacity.opacityWhite10,
        bgColorSecondary: colorPalette.shade.shade2,
        bgColorTertiary: colorPalette.opacity.opacityWhite40,
        bgColorQuaternary: colorPalette.shade.white,

        txtColor: colorPalette.text.textLight,
        txtColorSecondary: colorPalette.text.textSecondary,
        txtColorTertiary: colorPalette.text.textLight80,
    },
    inProgress: {
        bgColor: colorPalette.main.secondary,

        txtColor: colorPalette.text.textDark,
    },
    results: {
        bgColor: 'transparent',
        bgColorSecondary: 'transparent',
        bgColorTertiary: colorPalette.shade.shade1,

        txtColor: colorPalette.text.textLight,
        txtColorSecondary: colorPalette.text.textLight,
        txtColorTertiary: colorPalette.shade.white,
    },
};

export const betGlider = {
    bgColor: '',

    txtColor: '',
    txtColorSecondary: '',
};

export const stream = {
    bgColor: colorPalette.main.primary,
    txtColor: colorPalette.shade.white,
};

export const racingNextOff = {
    toggle: {
        bgColor: colorPalette.opacity.opacityWhite12,
        bgColorSecondary: colorPalette.shade.white,
        borderColor: colorPalette.shade.shade3,
        txtColor: colorPalette.text.textLight,
    },
    slider: {
        bgColor: colorPalette.shade.dark,
        bgColorSecondary: colorPalette.shade.shade1,
        txtColor: colorPalette.text.textLight,
    },
    raceBox: {
        bgColor: colorPalette.shade.shade5,
        bgColorSecondary: colorPalette.shade.shade2,
        bgColorTertiary: colorPalette.opacity.opacityWhite12,
        bgColorQuaternary: colorPalette.shade.white,
        bgColorQuinary: `linear-gradient(270deg, ${colorPalette.shade.shade4}, ${colorPalette.shade.shade3} 100%)`,

        borderColor: colorPalette.shade.shade2,
        borderColorSecondary: '',
        borderColorTertiary: '',
        txtColor: colorPalette.main.secondary,
        txtColorSecondary: colorPalette.text.textLight64,
        txtColorTertiary: colorPalette.text.textLight,
        txtColorQuaternary: colorPalette.text.textLight40,
    },
};

export const preMatch = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: gradients.gradientScoreboardLinear,
    bgColorTertiary: colorPalette.main.tertiary,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textSecondary,
    txtColorTertiary: colorPalette.text.textLight,
    txtColorQuaternary: colorPalette.text.textLight,
};

export const meetingsAntePost = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.shade.dark,
    bgColorTertiary: colorPalette.shade.shade1,
    bgColorQuaternary: colorPalette.shade.shade4,
    bgColorQuinary: colorPalette.opacity.opacityWhite20,
    bgColorSenary: colorPalette.shade.shade5,

    borderColor: colorPalette.shade.shade2,

    txtColor: colorPalette.shade.white,
    txtColorSecondary: colorPalette.text.textLight64,
    txtColorTertiary: colorPalette.opacity.opacityWhite20,

    typography: {
        fontSizePrimary: fontSize.small,
        fontWeightPrimary: fontWeight.regular,
        lineHeightPrimary: lineHeight[200],
    },
};

export const meetingsListColors = {
    bgColor: colorPalette.shade.shade1,
    bgColorSecondary: colorPalette.shade.dark,
    bgColorTertiary: colorPalette.shade.dark,
    bgColorQuaternary: '#39B54a',
    bgColorQuinary: colorPalette.opacity.opacityDark20,
    bgColorSenary: '#39B54a',

    txtColor: colorPalette.text.textLight,
};

export const meetingsRowColors = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.shade.white,
    bgColorTertiary: colorPalette.shade.shade5,
    txtColor: colorPalette.text.textSecondary,
    txtColorSecondary: colorPalette.text.textLight64,
    borderColor: colorPalette.shade.shade2,
    borderColorSecondary: colorPalette.shade.shade2,
    typography: {
        fontSizePrimary: fontSize.small,
        fontWeightPrimary: fontWeight.regular,
        lineHeightPrimary: lineHeight[200],
    },
};

export const selection = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.opacity.opacityWhite20,
    bgColorTertiary: colorPalette.main.secondary,
    bgColorQuaternary: colorPalette.main.secondary,
    bgColorQuinary: colorPalette.main.secondary,
    bgColorSenary: colorPalette.odds.oddsSuspended,
    bgColorSeptenary: `linear-gradient(90deg, ${colorPalette.shade.shade3} 0%, ${colorPalette.shade.shade4} 100%)`,

    txtColor: colorPalette.main.secondary,
    txtColorSecondary: colorPalette.text.textDark48,
    txtColorTertiary: colorPalette.text.textDark,
    txtColorQuaternary: colorPalette.text.textLight40,
    txtColorQuinary: colorPalette.text.textDark,

    borderColor: colorPalette.shade.shade2,
};

export const raceSummary = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.shade.shade4,
    bgColorTertiary: colorPalette.opacity.opacityDark20,
    bgColorQuaternary: colorPalette.shade.shade1,

    borderColor: colorPalette.shade.shade2,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight80,
    txtColorTertiary: colorPalette.text.textLight,
    txtColorQuaternary: colorPalette.text.textLight,
    typography: {
        fontSizePrimary: fontSize.small,
        fontSizeSecondary: fontSize.small,

        fontWeightPrimary: fontWeight.regular,

        lineHeightPrimary: lineHeight[200],
        lineHeightSecondary: lineHeight[200],
    },
};

export const quickPick = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.main.secondary,
    bgColorTertiary: colorPalette.opacity.opacityWhite12,
    bgColorQuaternary: colorPalette.shade.dark,
    bgColorQuinary: colorPalette.shade.shade5,
    bgColorSenary: colorPalette.status.statusSuccess,
    bgColorSeptenary: colorPalette.shade.shade1,
    bgColorOctonary: 'transparent',

    txtColor: colorPalette.shade.white,
    txtColorSecondary: colorPalette.text.textLight64,
    txtColorTertiary: colorPalette.text.textDark,
    txtColorQuaternary: '#020d16',
    txtColorQuinary: colorPalette.shade.white,
    txtColorSenary: colorPalette.text.textLight,

    borderColor: colorPalette.shade.shade2,

    typography: {
        fontSizePrimary: fontSize.xSmall,
        fontWeightPrimary: fontWeight.regular,
        lineHeightPrimary: lineHeight[150],
    },
};

export const checkbox = {
    dark: {
        bgColor: 'transparent',
        bgColorSecondary: colorPalette.main.tertiary,
        borderColor: colorPalette.opacity.opacityWhite20,
        borderColorSecondary: colorPalette.main.tertiary,
    },
    light: {
        bgColor: 'transparent',
        bgColorSecondary: colorPalette.main.secondary,
        borderColor: colorPalette.shade.shade3,
        borderColorSecondary: colorPalette.main.secondary,
    },
    bgColor: colorPalette.shade.dark,
};

export const commonConfirmationBox = {
    bgColor: colorPalette.shade.shade6,
    linkColor: colorPalette.text.textSecondary,
};

export const scrollbar = {
    light: {
        bgColor: colorPalette.opacity.opacityDark20,
    },
    dark: {
        bgColor: colorPalette.opacity.opacityWhite20,
    },
};

export const customScrollBar = {
    /** @deprecated - old should be removed */
    old: {
        bgColor: colorPalette.opacity.opacityWhite20,
        bgColorSecondary: colorPalette.main.secondary,
    },
    dark: {
        bgColor: 'transparent',
        bgColorSecondary: colorPalette.opacity.opacityDark20,
    },
    arrow: {
        bgColor: colorPalette.shade.white,
        bgColorSecondary: colorPalette.shade.dark,
        txtColor: colorPalette.shade.dark,
    },
};

export const sportEventNav = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.shade.shade1,
    bgColorTertiary: colorPalette.main.secondary,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textDark,
    txtColorTertiary: colorPalette.text.textLight,
    borderColor: 'transparent',
    borderColorSecondary: colorPalette.shade.white,
    borderColorTertiary: colorPalette.opacity.opacityWhite20,
};

export const eventRow = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.shade.shade5,
    bgColorTertiary: colorPalette.main.tertiary,
    bgColorQuaternary: colorPalette.shade.white,
    bgColorQuinary: colorPalette.main.secondary,

    borderColor: colorPalette.shade.shade2,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight64,
    txtColorTertiary: colorPalette.text.textLight,
    txtColorQuaternary: colorPalette.text.textSecondary,

    typography: {
        fontSizePrimary: fontSize.small,
        fontSizeSecondary: fontSize.xSmall,

        fontWeightPrimary: fontWeight.regular,
        fontWeightSecondary: fontWeight.xMedium,

        lineHeightPrimary: lineHeight[200],
        lineHeightSecondary: lineHeight[200],
        lineHeightTertiary: lineHeight[400],
    },
    gap: gap.xSmall,
};

export const eventRow6PackColors = {
    bgColor: colorPalette.shade.shade2,
    bgColorSecondary: colorPalette.main.tertiary,

    txtColor: colorPalette.main.secondary,
    txtColorSecondary: colorPalette.main.tertiary,
};

export const score = {
    color: {
        bgPrimary: colorPalette.main.tertiary,
        txtPrimary: colorPalette.text.textLight,
    },
    typography: {
        fontSizePrimary: fontSize.small,
        fontWeight: fontWeight.xMedium,
        lineHeightPrimary: lineHeight[200],
    },
    radius: radius.small,
    padding: padding.none,
};

export const americanSportMatchLead = {
    bgColor: colorPalette.main.secondary,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textSecondary,
    txtColorTertiary: colorPalette.status.statusSuccess,
};

export const tabsColors = {
    bgColor: colorPalette.shade.dark,
    txtColor: colorPalette.shade.white,
};

export const transactionHistory = {
    bgColor: colorPalette.odds.oddsDrifting,
    bgColorSecondary: colorPalette.odds.oddsShortening,
    bgColorTertiary: colorPalette.shade.shade3,

    borderColor: colorPalette.shade.shade6,
    borderColorSecondary: colorPalette.shade.shade5,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.status.statusError,
    txtColorQuaternary: colorPalette.text.textDark48,
    txtColorQuinary: colorPalette.text.textTertiary,
};

export const notifications = {
    notificationsPage: {
        bgColor: colorPalette.main.primary,
    },
    liveNotifications: {
        bgColor: colorPalette.shade.shade1,
        bgColorSecondary: colorPalette.opacity.opacityWhite20,
        bgColorTertiary: '',
        txtColor: colorPalette.text.textLight,
        txtColorSecondary: '',
    },
    marketing: {
        bgColor: colorPalette.shade.white,
        bgColorSecondary: colorPalette.opacity.opacityWhite20,
        bgColorTertiary: colorPalette.main.primary,
        txtColor: colorPalette.text.textDark,
        txtColorSecondary: colorPalette.text.textLight,
    },
};

export const staticPage = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.shade.shade2,
    txtColor: colorPalette.text.textDark,
    linkColor: colorPalette.text.textSecondary,
};

export const blockingPopUp = {
    txtColor: colorPalette.text.textSecondary,
    bgColor: colorPalette.opacity.opacityWhite10,
};

export const customKeyboard = {
    bgColor: '#f2f2f2',
    bgColorKey: colorPalette.shade.white,
    bgColorKeySpecial: '#ccc',
    borderColor: '#8c8c8c',
    txtColor: colorPalette.text.textDark,
};

export const errorModalLayoutColors = {
    bgColor: 'rgba(2, 13, 22, 0.5)',
    bgColorSecondary: '#fa5858',
    bgColorTertiary: colorPalette.shade.white,
    txtColor: '#444953',
    txtColorSecondary: '#444953',
};

export const popup = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.main.primary,
    bgColorQuaternary: colorPalette.opacity.opacityDark8,
    bgColorQuinary: colorPalette.opacity.opacityDark40,
    bgColorSenary: '#eeeeee',
    bgColorSeptenary: '#666666',
    bgColorOctonary: colorPalette.opacity.opacityDark20,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textLight,
    txtColorTertiary: '#eeeeee',
    txtColorQuaternary: colorPalette.text.textTertiary,
    txtColorQuinary: colorPalette.status.statusError,
    txtColorSenary: colorPalette.text.textTertiary,
};

export const addressesListColors = {
    bgColor: colorPalette.shade.shade6,
    txtColor: '#666666',
    txtColorSecondary: '#2a2a3c',
    borderColor: colorPalette.shade.white,
};

export const kycWarningColors = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.shade.shade6,
    txtColor: colorPalette.text.textDark,
    borderColor: colorPalette.shade.shade4,
};

export const mcbookieResetPassword = {
    bgColor: '',
    bgColorSecondary: '',
    txtColor: '',
    txtColorSecondary: '',
    borderColor: '',
    borderColorSecondary: '',
};

export const heroEvents = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.main.primary,
    bgColorTertiary: colorPalette.main.secondary,
    bgColorQuaternary: '#5e637a',
    bgColorQuinary: colorPalette.shade.shade3,
    bgColorSenary: colorPalette.main.primary,
    bgColorSeptenary: '',

    txtColor: colorPalette.shade.white,
    txtColorSecondary: colorPalette.main.primary,
    txtColorTertiary: colorPalette.main.secondary,

    borderColor: colorPalette.shade.white,
    borderColorSecondary: colorPalette.main.primary,
    borderColorTertiary: colorPalette.main.secondary,
};

export const scrollableLinksHeader = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.opacity.opacityWhite20,
};

export const notificationPromo = {
    txtColor: colorPalette.shade.white,
};

export const scoreboards = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.main.tertiary,
    bgColorTertiary: gradients.gradientScoreboardLinear,
    txtColor: colorPalette.shade.white,
    txtColorSecondary: colorPalette.main.tertiary,
    txtColorTertiary: colorPalette.text.textLight,
    txtColorQuaternary: colorPalette.shade.white,
    cricket: {
        bgColor: colorPalette.main.tertiary,
    },
    tennis: {
        bgColor: colorPalette.main.tertiary,
        bgColorSecondary: colorPalette.main.tertiary,
        txtColor: colorPalette.text.textLight,
        txtColorSecondary: colorPalette.shade.white,
    },
    football: {
        txtColorSecondary: colorPalette.main.secondary,
        txtColorTertiary: colorPalette.text.textLight,
    },
    basketball: {
        txtColorSecondary: colorPalette.text.textLight,
    },
};

export const pagination = {
    bgColor: colorPalette.opacity.opacityDark20,
    bgColorSecondary: colorPalette.shade.white,
    bgColorTertiary: colorPalette.main.secondary,
};

export const skeletonLoader = {
    placeholder: {
        bgColor: colorPalette.shade.dark,
        bgColorSecondary: colorPalette.shade.dark,
        bgColorTertiary: colorPalette.opacity.opacityWhite12,
        bgColorQuaternary: colorPalette.opacity.opacityWhite12,
        bgColorQuinary: colorPalette.opacity.opacityWhite20,
        bgColorSenary: colorPalette.opacity.opacityWhite12,
        bgColorSeptenary: colorPalette.shade.shade1,
        bgColorOctonary: colorPalette.opacity.opacityWhite12,
        bgColorNonary: colorPalette.opacity.opacityWhite12,
        bgColorDenary: colorPalette.opacity.opacityWhite12,
    },
    gradient: {
        bgColor: colorPalette.main.primary,
        bgColorSecondary: colorPalette.main.primary,
        bgColorTertiary: colorPalette.main.primary,
        bgColorQuaternary: colorPalette.opacity.opacityDark40, // Safari hack
        bgColorQuinary: colorPalette.opacity.opacityDark40,
        bgColorSenary: colorPalette.opacity.opacityDark40,
        bgColorSeptenary: colorPalette.opacity.opacityDark80,
        bgColorOctonary: 'rgba(0,0,0,0)',
        bgColorNonary: 'rgba(0,0,0,0)',
        bgColorDenary: 'rgba(0,0,0,0)',
        bgColorUndenary: 'rgba(0,0,0,0)',
    },
};

export const quickLinkTray = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.main.primary,
    txtColor: colorPalette.text.textLight,
};

export const zIndexGlobal = {
    /** below: -1 */
    below: -1,
    /** base: 0 */
    base: 0,
    /** above: 1 */
    above: 1,
    /** header: 4 */
    header: 4, // old 5
    /** footer: 3 */
    footer: 3, // old 5
    /** z-index: 2 */
    stream: 2, // old 5
    /** z-index: 10 */
    cookies: 10,
    /** z-index: 10 */
    bannerBox: 10,
    /** z-index: 11 */
    lhsMenu: 11,
    /** z-index: 11 */
    rhsMenu: 11,
    /** popup: 12 */
    popup: 12,
    /** z-index: 12 */
    floatingStream: 12,
    /** z-index: 2 */
    miniGamesGridMobile: 2,
    /** z-index: 9999 */
    highLevel: 9999,
};

export const zIndexLevelBase = {
    /** z-index: 2 */
    baseUp: 2,
    /** z-index: 20 */
    hightLevel: 20,
    /** z-index: 21 */
    hightLevelUp: 21,
};

export const zIndexBanners = {
    /** z-index: 6 */
    bannersWrapper: 6,
    /** z-index: 11 */
    marketingNotification: 11,
};

export const zIndexSelect = {
    /** z-index: 2 */
    optionWrapper: 2,
};

export const zIndexPopups = {
    /** z-index: 12 */
    marketingPopupWrapper: 12,
    /** z-index: 2 */
    signUpPopup: zIndexLevelBase.baseUp,
    /** z-index: 12 */
    deleteCardPopup: 12,
};

export const zIndexCasino = {
    /** z-index: 3 */
    miniGamesGameContainer: 3,
    /** z-index: 20 */
    errorWrapper: zIndexLevelBase.hightLevel,
    /** z-index: 21 */
    errorInner: zIndexLevelBase.hightLevelUp,
};

export const zIndexIdMission = {
    /** z-index: 20 */
    processingOverlay: zIndexLevelBase.hightLevel,
    /** z-index: 10010 */
    idMission: 10010,
};

export const homePageCarousel = {
    items: {
        bgColor: colorPalette.shade.dark,
        bgColorSecondary: colorPalette.opacity.opacityDark40,
        bgColorTertiary: colorPalette.shade.shade1,
        bgColorQuaternary: colorPalette.shade.dark,
        txtColor: colorPalette.text.textLight,
        txtColorSecondary: colorPalette.text.textLight64,
        txtColorTertiary: colorPalette.text.textLight,
    },
    controls: {
        bgColor: colorPalette.opacity.opacityDark80,
        bgColorSecondary: colorPalette.shade.white,
    },
    homePage: {
        bgColor: colorPalette.opacity.opacityWhite20,
        bgColorSecondary: colorPalette.main.secondary,
    },
    casino: {
        bgColor: colorPalette.opacity.opacityWhite20,
        bgColorSecondary: colorPalette.shade.white,
    },
};

export const depositPaymentMethods = {
    bgColor: colorPalette.shade.shade5,
    bgColorSecondary: '',

    txtColor: '',
    txtColorSecondary: '',
};

export const paymentMethodDropdown = {
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.main.tertiary,
    bgColorTertiary: colorPalette.opacity.opacityDark10,
    bgColorQuaternary: colorPalette.status.statusError,
    bgColorQuinary: colorPalette.opacity.opacityDark20,
    bgColorSenary: colorPalette.main.tertiary,

    borderColor: colorPalette.main.secondary,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textLight,
    txtColorTertiary: colorPalette.text.textDark48,
    txtColorQuaternary: colorPalette.text.textDark48,
    txtColorQuinary: colorPalette.text.textLight40,
    txtColorSenary: colorPalette.text.textLight,
};

export const blockingNotifications = {
    bgColor: colorPalette.shade.white,
    textColor: colorPalette.text.textDark,
};

export const pofModals = {
    bgColor: colorPalette.main.primary,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight64,
    txtColorTertiary: colorPalette.text.textSecondary,
};

export const monthlyActivityModals = {
    borderColor: colorPalette.opacity.opacityDark8,
};

export const srgQuestionnaire = {
    bgColor: colorPalette.main.primary,
    bgColorSecondary: colorPalette.opacity.opacityDark20,
    bgColorTertiary: colorPalette.opacity.opacityDark40,

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight64,
    txtColorTertiary: colorPalette.text.textLight40,
    txtColorQuaternary: colorPalette.text.textSecondary,
};

export const languageSwitcher = {
    bgColor: '',
    bgColorSecondary: '',
    bgColorTertiary: '',
    bgColorQuaternary: '',
    bgColorQuinary: '',
    txtColor: '',
    txtColorSecondary: '',
    txtColorTertiary: '',

    sidebar: {
        bgColor: '',
        bgColorSecondary: '',
        txtColor: '',
    },
};

export const cookieBot = {
    bgColor: colorPalette.main.secondary,
    bgColorSecondary: colorPalette.opacity.opacityDark8,
    bgColorTertiary: colorPalette.opacity.opacityDark20,
    bgColorQuaternary: colorPalette.shade.white,
    bgColorQuinary: colorPalette.opacity.opacityDark20,
    bgColorSenary: colorPalette.main.tertiary,
    bgColorSeptenary: colorPalette.opacity.opacityDark10,

    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textDark,
    txtColoTertiary: colorPalette.text.textTertiary,
    txtColorQuaternary: colorPalette.text.textDark,

    radius: radius.large,
    radiusSecondary: radius.small,
};

export const seoBox = {
    bgColor: colorPalette.shade.dark,
    borderColor: colorPalette.shade.shade2,

    txtColor: colorPalette.text.textSecondary,
    txtColorSecondary: colorPalette.text.textLight,

    casino: {
        txtColor: colorPalette.text.textLight,
        txtColorSecondary: colorPalette.text.textSecondary,
        borderColor: colorPalette.shade.dark,
    },
};

export const jackPotWidget = {
    bgColor: colorPalette.shade.dark,
    bgColorSecondary: colorPalette.opacity.opacityWhite12,
    txtColor: colorPalette.text.textLight,
    txtColorSecondary: 'linear-gradient(0deg, #ECC575, #FDE298, #ECC575 100%)',
};

export const gamblingSafetyTopBar = {
    bgColor: colorPalette.shade.shade1,
    bgColorSecondary: colorPalette.opacity.opacityWhite20,

    txtColor: colorPalette.opacity.opacityWhite80,
};

export const iconContainer = {
    bgColor: colorPalette.opacity.opacityDark10,
    bgColorSecondary: colorPalette.opacity.opacityWhite10,

    txtColor: colorPalette.text.textDark80,
    txtColorSecondary: colorPalette.text.textLight80,
    txtColorTertiary: colorPalette.text.textDark,
    txtColorQuaternary: colorPalette.opacity.opacityDark20,

    iconColor: colorPalette.opacity.opacityDark80,
    iconColorSecondary: colorPalette.opacity.opacityWhite80,
};

export const toggle = {
    opacity: colorPalette.opacity.opacityDark20,
    light: {
        bgColor: colorPalette.shade.white,
        bgColorSecondary: colorPalette.opacity.opacityDark20,
        bgColorTertiary: colorPalette.main.tertiary,
    },
    dark: {
        bgColor: colorPalette.shade.white,
        bgColorSecondary: colorPalette.opacity.opacityWhite20,
        bgColorTertiary: colorPalette.main.secondary,
    },
};

export const promoCodeInput = {
    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textTertiary,
    txtColorTertiary: colorPalette.status.statusError,
    txtColorQuaternary: colorPalette.shade.white,
    txtColorQuinary: colorPalette.text.textDark48,
    bgColor: colorPalette.shade.white,
    bgColorSecondary: colorPalette.status.statusSuccess,
    bgColorTertiary: colorPalette.status.statusError,
    borderColorPrimary: colorPalette.status.statusSuccess,
    borderColorSecondary: colorPalette.status.statusError,
    borderColorTertiary: colorPalette.main.secondary,
};

export const idMission = {
    bgColorPrimary: '#ccc',
    bgColorSecondary: '#ecedf3',
    bgColorTertiary: colorPalette.main.primary,
    bgColorQuaternary: colorPalette.status.statusSuccess,

    borderPrimary: colorPalette.opacity.opacityDark10,

    boxShadow: colorPalette.opacity.opacityDark8,
};

export const tableSportsRow = {
    horseRacingEvent: {
        bgColor: colorPalette.shade.shade5,
        txtColor: colorPalette.text.textLight,
        txtColorSecondary: colorPalette.text.textLight,

        fontSizePrimary: fontSize.small,
        fontSizeSecondary: fontSize.small,
        fontWeightPrimary: fontWeight.bold,
        fontWeightSecondary: fontWeight.regular,

        lineHeightPrimary: lineHeight[200],
        lineHeightSecondary: lineHeight[200],
    },
    link: {
        colors: {
            bgPrimary: colorPalette.shade.dark,
            bgSecondary: colorPalette.main.secondary,

            borderPrimary: colorPalette.shade.shade2,

            txtPrimary: colorPalette.text.textLight,
            txtSecondary: colorPalette.text.textLight40,
        },
        typography: {
            fontSizePrimary: fontSize.small,
            fontSizeSecondary: fontSize.xSmall,

            fontWeightPrimary: fontWeight.regular,

            lineHeightPrimary: lineHeight[200],
            lineHeightSecondary: lineHeight[150],
        },
    },
};

export const raceSectionHeader = {
    bgColor: colorPalette.shade.shade1,
    bgColorSecondary: colorPalette.opacity.opacityWhite10,

    borderColor: 'transparent',

    txtColor: colorPalette.text.textLight,
    txtColorSecondary: colorPalette.text.textLight40,
};

export const downloadAppBanner = {
    bgColor: '',
    bgColorSecondary: '',
    bgColorTertiary: '',

    txtColor: '',
    txtColorSecondary: '',
    txtColorTertiary: '',
};

export const button = {
    common: {
        typography: {
            fontSizePrimary: fontSize.small,
            fontSizeSecondary: fontSize.xRegular,
            fontSizeTertiary: fontSize.regular,

            fontWeightPrimary: fontWeight.bold,

            lineHeightPrimary: lineHeight[200],
            lineHeightSecondary: lineHeight[250],
            lineHeightTertiary: lineHeight[300],
        },
        radiusPrimary: radius.small,
        radiusSecondary: radius.small,
    },
    primary: {
        colors: {
            bgPrimary: colorPalette.main.secondary,
            bgSecondary: colorPalette.opacity.opacityDark10,

            txtPrimary: colorPalette.text.textDark,
        },
    },
    secondary: {
        colors: {
            bgPrimary: colorPalette.opacity.opacityDark10,
            bgSecondary: colorPalette.opacity.opacityDark20,

            txtPrimary: colorPalette.text.textDark,
        },
    },
    secondaryDark: {
        colors: {
            bgPrimary: colorPalette.opacity.opacityWhite10,
            bgSecondary: colorPalette.opacity.opacityWhite20,

            txtPrimary: colorPalette.text.textLight,
        },
    },
    danger: {
        colors: {
            bgPrimary: colorPalette.status.statusError,
            bgSecondary: colorPalette.opacity.opacityDark10,

            txtPrimary: colorPalette.text.textLight,
        },
    },
};

export const cardCasinoImage = {
    common: {
        typography: {
            fontSizePrimary: fontSize.xSmall,
            fontSizeSecondary: fontSize.small,

            fontWeightPrimary: fontWeight.bold,

            lineHeightPrimary: lineHeight[150],
            lineHeightSecondary: lineHeight[200],
        },
        radius: radius.medium,
    },
    colors: {
        bgPrimary: colorPalette.opacity.opacityDark40,
        bgSecondary: colorPalette.shade.white,

        txtPrimary: colorPalette.text.textLight,
    },
};

export const messages = {
    typography: {
        fontSize: fontSize.small,
        fontWeight: fontWeight.regular,
    },
    radius: radius.small,
};

export const multiDeposit = {
    bgColor: colorPalette.shade.shade6,
    bgColorSecondary: colorPalette.shade.dark,
    txtColor: colorPalette.text.textDark,
    txtColorSecondary: colorPalette.text.textDark80,
    bgApplePay: '#000000',
};

export const paymentMethod = {
    light: {
        bgColor: colorPalette.shade.shade6,
        txtColor: colorPalette.text.textDark,
        txtColorSecondary: colorPalette.opacity.opacityDark20,
    },

    dark: {
        bgColor: colorPalette.shade.shade1,

        txtColor: colorPalette.text.textLight,
    },

    bgColor: colorPalette.main.secondary,
};

export const liveTracker = {
    bgColor: colorPalette.shade.shade1,
};

export const optimoveInbox = {
    typography: {
        fontFamily: '',
    },
    bgColor: '',
    header: {
        bgColor: '',
        txtColor: '',
        bellBgColor: '',
        closeBtnBgColor: '',
    },
    message: {
        bgColorUnread: '',
        bgColorRead: '',
        titleTxtColor: '',
        bodyTxtColor: '',
        accentColor: '',
        actionBtnBgColor: '',
    },
    actionMenu: {
        bgColor: '',
        txtColor: '',
        txtColorHover: '',
    },
    badge: {
        bgColor: '',
        txtColor: '',
        borderColor: '',
        alertBgColor: '',
        alertTxtColor: '',
    },
};

export const midnightMigration = {
    bgColor: '',
    bgColorSecondary: '',
    bgColorTertiary: '',
    bgColorQuaternary: '',
    bgColorQuinary: '',
    bgColorSenary: '',
    bgColorSeptenary: '',
    bgColorOctonary: '',
    txtColor: '',
    txtColorSecondary: '',
    txtColorTertiary: '',
    txtColorQuaternary: '',
    txtColorQuinary: '',
    txtColorSenary: '',
    txtColorSeptenary: '',
    borderColor: '',
};
